import styled from "styled-components";

export const LikertScaleWrapper = styled.div`
  padding-top: 2rem;
  min-width: 0;
  max-width: 100%;
  overflow-wrap: break-word;
`;

export const LikertScaleAnswer = styled.div`
  padding-top: 1rem;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 12px;
`;

export const LikertScaleRange = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  width: 100%;
  
  > * {
    flex: 1 1 0;
    min-width: 0;
  }

  label {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    gap: 0.25rem;
  }

  input[type="radio"] {
    height: 20px;
    cursor: pointer;
    accent-color: var(--primary);
  }

  .radio-label {
    font-size: 14px;
    font-weight: 500;
    color: var(--text-primary);
  }

  .clear-button {
    border: 0px none;
    height: 20px;
    width: 40px;
    flex: none;
    color: var(--primary);
    background-color: transparent;
  }
`;
